import { render, staticRenderFns } from "./validate-option.vue?vue&type=template&id=3be59cf7&scoped=true"
import script from "./validate-option.vue?vue&type=script&lang=js"
export * from "./validate-option.vue?vue&type=script&lang=js"
import style0 from "./validate-option.vue?vue&type=style&index=0&id=3be59cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be59cf7",
  null
  
)

export default component.exports